/**
 * Iniziali da mostrare nel bottone dell'utente in alto a destra.
 *
 * Il nome in redazione sta nel campo `blogger` e non e' sempre "Nome Cognome":
 * a volte e' una sigla, a volte una parola sola. Meglio due lettere che un
 * segnaposto vuoto.
 */
export function iniziali(nome: string | null | undefined): string {
  const parole = (nome ?? '').trim().split(/\s+/).filter(Boolean);
  if (parole.length === 0) return '?';
  if (parole.length === 1) return parole[0].slice(0, 2).toUpperCase();
  return (parole[0][0] + parole[parole.length - 1][0]).toUpperCase();
}
